// import React, { useState, useEffect } from 'react';
// import apiService from '../config';

// const Section93 = () => {
//   const [rows, setRows] = useState([]);
//   const [projectId, setProjectId] = useState(null);
//   const [proposalId, setProposalId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [editedFields, setEditedFields] = useState({}); // Track edited fields per row as an array

//   // Fetch projectId and proposalId from localStorage
//   useEffect(() => {
//     const getProjectInfo = () => {
//       const currentProjectData = localStorage.getItem('currentProjectData');
//       if (currentProjectData) {
//         try {
//           const projectData = JSON.parse(currentProjectData);
//           setProjectId(projectData.project_id || projectData.id);
//         } catch (e) {
//           console.error('Error parsing current project data:', e);
//         }
//       }

//       const userData = localStorage.getItem('userData');
//       if (userData) {
//         try {
//           const user = JSON.parse(userData);
//           setProposalId(user.data?.default_proposal || user.default_proposal || null);
//         } catch (e) {
//           console.error('Error parsing user data:', e);
//         }
//       }
//     };

//     getProjectInfo();
//   }, []);

//   // Fetch initial rows data using apiService
//   useEffect(() => {
//     if (projectId && proposalId) {
//       const fetchData = async () => {
//         setLoading(true);
//         try {
//           const response = await apiService.get("getAllOwner", {
//             projectId: projectId,
//             proposalId: proposalId,
//             isActive: 1
//           });

//           const mappedRows = response.landAcquisition?.flatMap(acquisition =>
//             acquisition.owners.map(owner => ({
//               id: owner.land_owner_id,
//               surveyNo: acquisition.survey_no || '',
//               vargikaran: 'No',
//               kshetra: owner.owner_aqr_area || '',
//               bhudharanBadal: owner.owner_name || '',
//               kshetraNew: '',
//               bhudharanBadalNew: ''
//             }))
//           ) || [];

//           setRows(mappedRows.length > 0 ? mappedRows : [{
//             id: 1,
//             surveyNo: '',
//             vargikaran: 'No',
//             kshetra: '',
//             bhudharanBadal: '',
//             kshetraNew: '',
//             bhudharanBadalNew: ''
//           }]);
//         } catch (err) {
//           console.error('Error fetching data:', err);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchData();
//     }
//   }, [projectId, proposalId]);

//   const handleDropdownChange = (id, field, value) => {
//     setRows(rows.map(row => {
//       if (row.id === id) {
//         const updatedRow = { ...row, [field]: value };
//         // If set to No, clear the editable fields
//         if (value === 'No') {
//           updatedRow.kshetraNew = '';
//           updatedRow.bhudharanBadalNew = '';
//         }
//         return updatedRow;
//       }
//       return row;
//     }));
//     // Reset edited fields tracking when dropdown changes
//     setEditedFields(prev => ({ ...prev, [id]: [] }));
//   };

//   const handleInputChange = (id, field, value) => {
//     setRows(rows.map(row =>
//       row.id === id ? { ...row, [field]: value } : row
//     ));
//     // Add the edited field to the array if not already present
//     setEditedFields(prev => ({
//       ...prev,
//       [id]: prev[id] ? [...new Set([...prev[id], field])] : [field]
//     }));
//   };

//   const handleSave = async (id) => {
//     if (!projectId || !proposalId) {
//       alert('Project or Proposal ID not found');
//       return;
//     }

//     const rowToSave = rows.find(row => row.id === id);
//     const fieldsToSave = editedFields[id] || [];

//     // If no fields were edited, prevent save
//     if (fieldsToSave.length === 0) {
//       alert('No field edited');
//       return;
//     }

//     setLoading(true);
//     try {
//       const measurementData = {};
//       // Include only edited fields in the API call
//       if (fieldsToSave.includes('kshetraNew')) {
//         measurementData.owner_aqr_area = rowToSave.kshetraNew;
//       }
//       if (fieldsToSave.includes('bhudharanBadalNew')) {
//         measurementData.owner_name = rowToSave.bhudharanBadalNew;
//       }

//       await apiService.patchUpdateMeasurement(id, measurementData);

//       // Update the original fields with new values and set vargikaran to No
//       setRows(rows.map(row => {
//         if (row.id === id) {
//           return {
//             ...row,
//             vargikaran: 'No',
//             kshetra: fieldsToSave.includes('kshetraNew') ? rowToSave.kshetraNew : row.kshetra,
//             bhudharanBadal: fieldsToSave.includes('bhudharanBadalNew') ? rowToSave.bhudharanBadalNew : row.bhudharanBadal,
//             kshetraNew: '',
//             bhudharanBadalNew: ''
//           };
//         }
//         return row;
//       }));

//       // Clear edited fields tracking for this row
//       setEditedFields(prev => ({ ...prev, [id]: [] }));

//       alert('Row saved successfully');
//     } catch (err) {
//       console.error('Error saving row:', err);
//       alert('Failed to save row');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isEditable = (row) => {
//     return row.vargikaran === 'Yes';
//   };

//   if (loading) {
//     return <div>Loading data...</div>;
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8">
//       <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-8">
//         {/* Main Heading */}
//         <div className="text-center mb-6">
//           <h1 className="text-3xl font-bold text-indigo-900 mb-2">
//             निवडा साडी अंतिम करणे
//           </h1>
//           <h2 className="text-xl font-semibold text-indigo-700 mb-4">
//             क्षेत्र वगळणची कार्यवाही
//           </h2>
//         </div>

//         {/* Table */}
//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse border-2 border-indigo-300">
//             <thead>
//               <tr className="bg-indigo-600 text-white">
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">
//                   अ.क्र.
//                 </th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">
//                   गट नं
//                 </th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">
//                   वगळण
//                 </th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">
//                   क्षेत्र
//                 </th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">
//                   भूधाराकाचे नाव
//                 </th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-center">
//                   कृती
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((row, index) => (
//                 <tr key={row.id} className="hover:bg-indigo-50 transition-colors">
//                   {/* Serial Number */}
//                   <td className="border-2 border-indigo-200 px-4 py-3 font-semibold">
//                     {index + 1}
//                   </td>

//                   {/* गट नं Input (surveyNo, disabled) */}
//                   <td className="border-2 border-indigo-200 px-4 py-3">
//                     <input
//                       type="text"
//                       value={row.surveyNo}
//                       disabled
//                       className="w-full px-3 py-2 cursor-not-allowed"
//                       placeholder="गट नं"
//                     />
//                   </td>

//                   {/* वर्गकन Dropdown */}
//                   <td className="border-2 border-indigo-200 px-4 py-3">
//                     <select
//                       value={row.vargikaran}
//                       onChange={(e) => handleDropdownChange(row.id, 'vargikaran', e.target.value)}
//                       className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                     >
//                       <option value="No">No</option>
//                       <option value="Yes">Yes</option>
//                     </select>
//                   </td>

//                   {/* क्षेत्र Input Fields */}
//                   <td className="border-2 border-indigo-200 px-4 py-3">
//                     <input
//                       type="text"
//                       value={row.kshetra}
//                       disabled
//                       className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
//                       placeholder=""
//                     />
//                     {isEditable(row) && (
//                       <input
//                         type="text"
//                         value={row.kshetraNew}
//                         onChange={(e) => handleInputChange(row.id, 'kshetraNew', e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                         placeholder="नवीन क्षेत्र प्रविष्ट करा"
//                       />
//                     )}
//                   </td>

//                   {/* भूधाराकाचे नाव Input Fields */}
//                   <td className="border-2 border-indigo-200 px-4 py-3">
//                     <input
//                       type="text"
//                       value={row.bhudharanBadal}
//                       disabled
//                       className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
//                       placeholder=""
//                     />
//                     {isEditable(row) && (
//                       <input
//                         type="text"
//                         value={row.bhudharanBadalNew}
//                         onChange={(e) => handleInputChange(row.id, 'bhudharanBadalNew', e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                         placeholder="नवीन भूधाराकाचे नाव प्रविष्ट करा"
//                       />
//                     )}
//                   </td>

//                   {/* Save Button */}
//                   <td className="border-2 border-indigo-200 px-4 py-3 text-center">
//                     <button
//                       onClick={() => handleSave(row.id)}
//                       disabled={loading || !isEditable(row) || !editedFields[row.id]?.length}
//                       className={`px-3 py-1 rounded font-semibold transition-colors ${loading || !isEditable(row) || !editedFields[row.id]?.length
//                           ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                           : 'bg-blue-500 hover:bg-blue-600 text-white'
//                         }`}
//                     >
//                       {loading ? 'Saving...' : 'सेव्ह करा'}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section93;

// import React, { useState, useEffect } from 'react';
// import apiService from '../config';

// const Section93 = () => {
//   const [rows, setRows] = useState([]);
//   const [projectId, setProjectId] = useState(null);
//   const [proposalId, setProposalId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [editedFields, setEditedFields] = useState({});

//   useEffect(() => {
//     const getProjectInfo = () => {
//       const currentProjectData = localStorage.getItem('currentProjectData');
//       if (currentProjectData) {
//         try {
//           const projectData = JSON.parse(currentProjectData);
//           setProjectId(projectData.project_id || projectData.id);
//         } catch (e) {
//           console.error('Error parsing current project data:', e);
//         }
//       }

//       const userData = localStorage.getItem('userData');
//       if (userData) {
//         try {
//           const user = JSON.parse(userData);
//           setProposalId(user.data?.default_proposal || user.default_proposal || null);
//         } catch (e) {
//           console.error('Error parsing user data:', e);
//         }
//       }
//     };

//     getProjectInfo();
//   }, []);

//   useEffect(() => {
//     if (projectId && proposalId) {
//       const fetchData = async () => {
//         setLoading(true);
//         try {
//           const response = await apiService.get("getAllOwner", {
//             projectId: projectId,
//             proposalId: proposalId,
//             isActive: 1
//           });

//           // ✅ 1. Added villageName to the mapped object
//           const mappedRows = response.landAcquisition?.flatMap(acquisition =>
//             acquisition.owners.map(owner => ({
//               id: owner.land_owner_id,
//               surveyNo: acquisition.survey_no || '',
//               villageName: acquisition.village_name || 'माहिती नाही', // Fallback if missing
//               vargikaran: 'No',
//               kshetra: owner.owner_aqr_area || '',
//               bhudharanBadal: owner.owner_name || '',
//               kshetraNew: '',
//               bhudharanBadalNew: ''
//             }))
//           ) || [];

//           setRows(mappedRows.length > 0 ? mappedRows : [{
//             id: 1,
//             surveyNo: '',
//             villageName: 'माहिती नाही',
//             vargikaran: 'No',
//             kshetra: '',
//             bhudharanBadal: '',
//             kshetraNew: '',
//             bhudharanBadalNew: ''
//           }]);
//         } catch (err) {
//           console.error('Error fetching data:', err);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchData();
//     }
//   }, [projectId, proposalId]);

//   const handleDropdownChange = (id, field, value) => {
//     setRows(rows.map(row => {
//       if (row.id === id) {
//         const updatedRow = { ...row, [field]: value };
//         if (value === 'No') {
//           updatedRow.kshetraNew = '';
//           updatedRow.bhudharanBadalNew = '';
//         }
//         return updatedRow;
//       }
//       return row;
//     }));
//     setEditedFields(prev => ({ ...prev, [id]: [] }));
//   };

//   const handleInputChange = (id, field, value) => {
//     setRows(rows.map(row =>
//       row.id === id ? { ...row, [field]: value } : row
//     ));
//     setEditedFields(prev => ({
//       ...prev,
//       [id]: prev[id] ? [...new Set([...prev[id], field])] : [field]
//     }));
//   };

//   const handleSave = async (id) => {
//     if (!projectId || !proposalId) {
//       alert('Project or Proposal ID not found');
//       return;
//     }

//     const rowToSave = rows.find(row => row.id === id);
//     const fieldsToSave = editedFields[id] || [];

//     if (fieldsToSave.length === 0) {
//       alert('No field edited');
//       return;
//     }

//     setLoading(true);
//     try {
//       const measurementData = {};
//       if (fieldsToSave.includes('kshetraNew')) {
//         measurementData.owner_aqr_area = rowToSave.kshetraNew;
//       }
//       if (fieldsToSave.includes('bhudharanBadalNew')) {
//         measurementData.owner_name = rowToSave.bhudharanBadalNew;
//       }

//       await apiService.patchUpdateMeasurement(id, measurementData);

//       setRows(rows.map(row => {
//         if (row.id === id) {
//           return {
//             ...row,
//             vargikaran: 'No',
//             kshetra: fieldsToSave.includes('kshetraNew') ? rowToSave.kshetraNew : row.kshetra,
//             bhudharanBadal: fieldsToSave.includes('bhudharanBadalNew') ? rowToSave.bhudharanBadalNew : row.bhudharanBadal,
//             kshetraNew: '',
//             bhudharanBadalNew: ''
//           };
//         }
//         return row;
//       }));

//       setEditedFields(prev => ({ ...prev, [id]: [] }));
//       alert('Row saved successfully');
//     } catch (err) {
//       console.error('Error saving row:', err);
//       alert('Failed to save row');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isEditable = (row) => {
//     return row.vargikaran === 'Yes';
//   };

//   // ✅ 2. Group the rows by villageName dynamically
//   const groupedRows = rows.reduce((groups, row) => {
//     const village = row.villageName || 'माहिती नाही';
//     if (!groups[village]) {
//       groups[village] = [];
//     }
//     groups[village].push(row);
//     return groups;
//   }, {});

//   if (loading) {
//     return <div>Loading data...</div>;
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8">
//       <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-8">
//         <div className="text-center mb-6">
//           <h1 className="text-3xl font-bold text-indigo-900 mb-2">
//             निवडा साडी अंतिम करणे
//           </h1>
//           <h2 className="text-xl font-semibold text-indigo-700 mb-4">
//             क्षेत्र वगळणची कार्यवाही
//           </h2>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse border-2 border-indigo-300">
//             <thead>
//               <tr className="bg-indigo-600 text-white">
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">अ.क्र.</th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">गट नं</th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">वगळण</th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">क्षेत्र (हे.आर)</th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-left">भूधाराकाचे नाव</th>
//                 <th className="border-2 border-indigo-400 px-4 py-3 text-center">कृती</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* ✅ 3. Map over the grouped object instead of the flat array */}
//               {Object.entries(groupedRows).map(([villageName, villageRows]) => (
//                 <React.Fragment key={villageName}>
//                   {/* Village Title Row */}
//                   <tr className="bg-indigo-200">
//                     <td 
//                       colSpan="6" 
//                       className="border-2 border-indigo-300 px-4 py-2 font-bold text-indigo-900 text-center text-lg"
//                     >
//                       गाव: {villageName}
//                     </td>
//                   </tr>

//                   {/* Data Rows for the specific village */}
//                   {villageRows.map((row, index) => (
//                     <tr key={row.id} className="hover:bg-indigo-50 transition-colors">
//                       <td className="border-2 border-indigo-200 px-4 py-3 font-semibold">
//                         {index + 1}
//                       </td>
//                       <td className="border-2 border-indigo-200 px-4 py-3">
//                         <input
//                           type="text"
//                           value={row.surveyNo}
//                           disabled
//                           className="w-full px-3 py-2 cursor-not-allowed"
//                           placeholder="गट नं"
//                         />
//                       </td>
//                       <td className="border-2 border-indigo-200 px-4 py-3">
//                         <select
//                           value={row.vargikaran}
//                           onChange={(e) => handleDropdownChange(row.id, 'vargikaran', e.target.value)}
//                           className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                         >
//                           <option value="No">No</option>
//                           <option value="Yes">Yes</option>
//                         </select>
//                       </td>
//                       <td className="border-2 border-indigo-200 px-4 py-3">
//                         <input
//                           type="text"
//                           value={row.kshetra}
//                           disabled
//                           className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
//                           placeholder=""
//                         />
//                         {isEditable(row) && (
//                           <input
//                             type="text"
//                             value={row.kshetraNew}
//                             onChange={(e) => handleInputChange(row.id, 'kshetraNew', e.target.value)}
//                             className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                             placeholder="नवीन क्षेत्र प्रविष्ट करा"
//                           />
//                         )}
//                       </td>
//                       <td className="border-2 border-indigo-200 px-4 py-3">
//                         <input
//                           type="text"
//                           value={row.bhudharanBadal}
//                           disabled
//                           className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
//                           placeholder=""
//                         />
//                         {isEditable(row) && (
//                           <input
//                             type="text"
//                             value={row.bhudharanBadalNew}
//                             onChange={(e) => handleInputChange(row.id, 'bhudharanBadalNew', e.target.value)}
//                             className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
//                             placeholder="नवीन भूधाराकाचे नाव प्रविष्ट करा"
//                           />
//                         )}
//                       </td>
//                       <td className="border-2 border-indigo-200 px-4 py-3 text-center">
//                         <button
//                           onClick={() => handleSave(row.id)}
//                           disabled={loading || !isEditable(row) || !editedFields[row.id]?.length}
//                           className={`px-3 py-1 rounded font-semibold transition-colors ${loading || !isEditable(row) || !editedFields[row.id]?.length
//                               ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                               : 'bg-blue-500 hover:bg-blue-600 text-white'
//                             }`}
//                         >
//                           {loading ? 'Saving...' : 'सेव्ह करा'}
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section93;


import React, { useState, useEffect } from 'react';
import { RefreshCw, X, Send, FileText } from "lucide-react";
import { useLanguage } from "../StoreContext/LanguageContext";
import { useSignature } from "../DigitalSignature/UseSignatue";
import SignaturePad from "../DigitalSignature/SignaturePad";
import apiService from '../config';

// ==========================================
// REUSABLE DOCUMENT FORWARD MODAL COMPONENT
// ==========================================
const DocumentForwardModal = ({
  isOpen,
  onClose,
  title,
  users,
  loadingUsers,
  userLabel,
  targetRole,
  currentUserRole,
  ROLES,
  onSubmit,
  isSubmitting,
  translations,
  language,
  initialUser = "",
  initialRemarks = "Approved",
  uploadStatus,
  selectedSignDocument,
  setShowSignaturePad,
  setPdfForSigning,
  handleViewDocument
}) => {
  const [selectedUser, setSelectedUser] = useState(initialUser);
  const [remarks, setRemarks] = useState(initialRemarks);
  const [document, setDocument] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedUser(initialUser);
      setRemarks(initialRemarks);
    } else {
      setSelectedUser("");
      setRemarks("Approved");
      setDocument(null);
    }
  }, [isOpen, initialUser, initialRemarks]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    let finalDoc = document;

    // Apply the signed document if the signature was successful
    if (uploadStatus === "success" && selectedSignDocument) {
      finalDoc = selectedSignDocument;
    }

    onSubmit({ selectedUser, remarks, document: finalDoc });
  };

  const isSubmitDisabled = isSubmitting || !selectedUser || !document;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">{title}</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">{userLabel} *</label>
              <select 
                value={selectedUser} 
                onChange={(e) => setSelectedUser(e.target.value)} 
                disabled={loadingUsers} 
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">{loadingUsers ? "Loading users..." : "Select User"}</option>
                {users?.map((user) => (
                  <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                    {user.full_name || user.user_name} ({user.usr_role || user.user_role || "Officer"})
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">{translations?.[language]?.Remarks || "Remarks"}</label>
              <textarea 
                value={remarks} 
                onChange={(e) => setRemarks(e.target.value)} 
                rows={3} 
                className="w-full p-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                placeholder="Enter remarks..." 
              />
            </div>

            {/* Single Document Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Upload Document *</label>
              <input 
                type="file" 
                onChange={(e) => setDocument(e.target.files[0])} 
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" 
              />
              
              {document && (
                <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">Selected: {document.name}</p>
                  </div>
                  <div className="flex gap-2">
                    {document.type === "application/pdf" && (
                      <button 
                        type="button" 
                        onClick={() => { 
                          setPdfForSigning(document); 
                          setShowSignaturePad(true); 
                        }} 
                        disabled={uploadStatus === "uploading"} 
                        className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400"
                      >
                        {uploadStatus === "uploading" ? "Signing..." : "Sign Doc"}
                      </button>
                    )}
                    <button 
                      type="button" 
                      onClick={() => {
                        const docToView = (uploadStatus === "success" && selectedSignDocument) 
                          ? selectedSignDocument 
                          : document;
                        handleViewDocument(docToView);
                      }} 
                      className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      View
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-5 pt-4 border-t border-gray-100">
            <button 
              onClick={onClose} 
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50" 
              disabled={isSubmitting}
            >
             {translations?.[language]?.Cancel || "Cancel"}
            </button>
            <button 
              onClick={handleSubmit} 
              disabled={isSubmitDisabled} 
              className={`px-6 py-2 rounded-lg text-white font-medium shadow-md transition-colors flex items-center ${
                isSubmitDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800"
              }`}
            >
              {isSubmitting ? (translations?.[language]?.Sending || "Sending...") : (translations?.[language]?.Send || "Send")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// MAIN COMPONENT
// ==========================================
const Section93 = () => {
  const { language = 'en', translations = {} } = useLanguage() || {};

  // Original State
  const [rows, setRows] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editedFields, setEditedFields] = useState({});

  // ==========================================
  // NEW STATE: Roles, Users & Forwarding Logic
  // ==========================================
  const ROLES = { COLLECTOR: 1, LAO: 3, SAMANVAY: 6, PROJECT_INCHARGE: 18, DATA_ENTRY: 14 };
  const [userRole, setUserRole] = useState(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const user = JSON.parse(userData);
      return user.user_role || null;
    }
    return null;
  });

  const [activeModal, setActiveModal] = useState(null); // 'SAMANVAY' | 'COLLECTOR' | 'LAO' | null
  const [isSubmittingTask, setIsSubmittingTask] = useState(false);
  const [restoredModalData, setRestoredModalData] = useState({ user: "", remarks: "Approved" });

  const [usersSamanvay, setusersSamanvay] = useState([]);
  const [loadingusersSamanvay, setLoadingusersSamanvay] = useState(false);
  
  const [usersCollectorAll, setusersCollectorAll] = useState([]);
  const [loadingusersCollector, setLoadingusersCollector] = useState(false);

  const [usersLAO, setusersLAO] = useState([]);
  const [loadingusersLAO, setLoadingusersLAO] = useState(false);

  const [isSamanvay, setIsSamanvay] = useState(false);
  const [isCollector, setIsCollector] = useState(false);
  const [isSamanvayFinal, setIsSamanvayFinal] = useState(false);
  const [isLAO, setIsLAO] = useState(false);

  const [notification, setNotification] = useState({ show: false, message: "", type: "" });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({ title: "", message: "", onConfirm: null, onCancel: null, type: "warning" });

  // Digital Signature & Document Viewer
  const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature() || {};
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [showDocumentViewer, setShowDocumentViewer] = useState(false); 
  const [fileUrlToView, setFileUrlToView] = useState("");
  const [isPDFToView, setIsPDFToView] = useState(false);

  // ==========================================
  // INITIALIZATION EFFECT
  // ==========================================
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          setProjectId(projectData.project_id || projectData.id);
        } catch (e) {
          console.error('Error parsing current project data:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          setProposalId(user.data?.default_proposal || user.default_proposal || null);
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
    };

    getProjectInfo();
  }, []);

  // Fetch Rows Data
  useEffect(() => {
    if (projectId && proposalId) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await apiService.get("getAllOwner", {
            projectId: projectId,
            proposalId: proposalId,
            isActive: 1
          });

          const mappedRows = response.landAcquisition?.flatMap(acquisition =>
            acquisition.owners.map(owner => ({
              id: owner.land_owner_id,
              surveyNo: acquisition.survey_no || '',
              villageName: acquisition.village_name || 'माहिती नाही',
              vargikaran: 'No',
              kshetra: owner.owner_aqr_area || '',
              bhudharanBadal: owner.owner_name || '',
              kshetraNew: '',
              bhudharanBadalNew: ''
            }))
          ) || [];

          setRows(mappedRows.length > 0 ? mappedRows : [{
            id: 1, surveyNo: '', villageName: 'माहिती नाही', vargikaran: 'No',
            kshetra: '', bhudharanBadal: '', kshetraNew: '', bhudharanBadalNew: ''
          }]);
        } catch (err) {
          console.error('Error fetching data:', err);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [projectId, proposalId]);

  // Fetch Button Statuses (Send to Samanvay, LAO, Collector)
  useEffect(() => {
    const fetchButtonState = async () => {
      try {
        if (!projectId || !proposalId) return;
        const res = await apiService.getTrackingwiseSEC15Button(projectId, proposalId);
        setIsSamanvay(res?.stages?.ObjectionSamanvay?.complete);
        setIsCollector(res?.stages?.ObjectionCollector?.complete);
        setIsSamanvayFinal(res?.stages?.ObjectionSamanvay?.complete);
        setIsLAO(res?.stages?.ObjectionLAO?.complete);
      } catch (error) {
        console.error("Error fetching button state:", error);
      }
    }; 
    fetchButtonState();
  }, [projectId, proposalId]);

  // Fetch Users based on Active Modal
  useEffect(() => {
    if (activeModal === 'COLLECTOR') fetchUsersAllCollector();
    if (activeModal === 'SAMANVAY') fetchusersSamanvay();
    if (activeModal === 'LAO') fetchusersLAOList();
  }, [activeModal]);

  // ==========================================
  // HANDLERS (Original & New)
  // ==========================================
  const handleDropdownChange = (id, field, value) => {
    setRows(rows.map(row => {
      if (row.id === id) {
        const updatedRow = { ...row, [field]: value };
        if (value === 'No') {
          updatedRow.kshetraNew = '';
          updatedRow.bhudharanBadalNew = '';
        }
        return updatedRow;
      }
      return row;
    }));
    setEditedFields(prev => ({ ...prev, [id]: [] }));
  };

  const handleInputChange = (id, field, value) => {
    setRows(rows.map(row =>
      row.id === id ? { ...row, [field]: value } : row
    ));
    setEditedFields(prev => ({
      ...prev,
      [id]: prev[id] ? [...new Set([...prev[id], field])] : [field]
    }));
  };

  const handleSave = async (id) => {
    if (!projectId || !proposalId) {
      alert('Project or Proposal ID not found');
      return;
    }

    const rowToSave = rows.find(row => row.id === id);
    const fieldsToSave = editedFields[id] || [];

    if (fieldsToSave.length === 0) {
      alert('No field edited');
      return;
    }

    setLoading(true);
    try {
      const measurementData = {};
      if (fieldsToSave.includes('kshetraNew')) {
        measurementData.owner_aqr_area = rowToSave.kshetraNew;
      }
      if (fieldsToSave.includes('bhudharanBadalNew')) {
        measurementData.owner_name = rowToSave.bhudharanBadalNew;
      }

      await apiService.patchUpdateMeasurement(id, measurementData);

      setRows(rows.map(row => {
        if (row.id === id) {
          return {
            ...row,
            vargikaran: 'No',
            kshetra: fieldsToSave.includes('kshetraNew') ? rowToSave.kshetraNew : row.kshetra,
            bhudharanBadal: fieldsToSave.includes('bhudharanBadalNew') ? rowToSave.bhudharanBadalNew : row.bhudharanBadal,
            kshetraNew: '',
            bhudharanBadalNew: ''
          };
        }
        return row;
      }));

      setEditedFields(prev => ({ ...prev, [id]: [] }));
      alert('Row saved successfully');
    } catch (err) {
      console.error('Error saving row:', err);
      alert('Failed to save row');
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // NEW HANDLERS: Fetch Users & Submissions
  // ==========================================
  const fetchUsersAllCollector = async () => {
    const role = 1;
    setLoadingusersCollector(true);
    try {
      const response = await apiService.getAllAssignUserCollector(role, projectId, proposalId);
      if (response.status === 200 && response.data) setusersCollectorAll(Array.isArray(response.data) ? response.data : []);
      else setusersCollectorAll([]);
    } catch (error) {
      setusersCollectorAll([]);
    } finally {
      setLoadingusersCollector(false);
    }
  };

  const fetchusersSamanvay = async () => {
    const role = 6;
    setLoadingusersSamanvay(true);
    try {
      const response = await apiService.getAllAssignUserRoleSamanvay(role, projectId, proposalId);
      if (response.status === 200 && response.data) setusersSamanvay(Array.isArray(response.data) ? response.data : []);
      else setusersSamanvay([]);
    } catch (error) {
      setusersSamanvay([]);
    } finally {
      setLoadingusersSamanvay(false);
    }
  };

  const fetchusersLAOList = async () => {
    const role = 3;
    setLoadingusersLAO(true);
    try {
      const response = await apiService.getAssignLAO(role, projectId, proposalId);
      if (response.status === 200 && response.data) setusersLAO(Array.isArray(response.data) ? response.data : []);
      else setusersLAO([]);
    } catch (error) {
      setusersLAO([]);
    } finally {
      setLoadingusersLAO(false);
    }
  };

  // Unified Submit for a Single Document
  const handleUnifiedSubmit = async ({ selectedUser, remarks, document }) => {
    if (!projectId || !proposalId) {
      setNotification({ show: true, type: "error", message: "Project ID and Proposal ID are required." });
      return;
    }

    setIsSubmittingTask(true);
    try {
      const formData = new FormData();
      formData.append("project_id", projectId);
      formData.append("proposal_id", proposalId);
      formData.append("remarks", remarks || "Approved");
      formData.append("usr_id", selectedUser);

      if (document) formData.append("document", document);

      let response;
      if (activeModal === 'COLLECTOR') {
        response = await apiService.postTrackingCollectorObjection(formData);
      } else if (activeModal === 'LAO') {
        response = await apiService.postTrackingLAOObjection(formData);
      } else if (activeModal === 'SAMANVAY') {
        if (userRole === ROLES.LAO) {
          response = await apiService.postTrackingSamanvayObjection(formData);
        } else if (userRole === ROLES.COLLECTOR) {
          response = await apiService.postTrackingSamanvayFinalObjection(formData);
        }
      }

      if (response && (response.status === 200 || response.status === 201)) {
        setNotification({ show: true, type: "success", message: `Successfully sent to ${activeModal} Officer!` });
        if (resetSignatureState) resetSignatureState();
        setActiveModal(null);
      } else {
        throw new Error(`Unexpected response status: ${response?.status}`);
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setNotification({ show: true, type: "error", message: `Failed to send to ${activeModal} Officer. Please try again.` });
    } finally {
      setIsSubmittingTask(false);
    }
  };

  const getModalConfig = () => {
    switch (activeModal) {
      case 'SAMANVAY':
        return {
          title: translations?.[language]?.SendToSamanvayOfficer || "Send to Samanvay Officer",
          userLabel: translations?.[language]?.selectUserSamanvayOfficer || "Select Samanvay Officer",
          users: usersSamanvay,
          loadingUsers: loadingusersSamanvay
        };
      case 'COLLECTOR':
        return {
          title: "Send to Collector",
          userLabel: translations?.[language]?.SelectUserCollector || "Select Collector",
          users: usersCollectorAll,
          loadingUsers: loadingusersCollector
        };
      case 'LAO':
        return {
          title: "Send to LAO",
          userLabel: translations?.[language]?.SelectUserLAO || "Select LAO",
          users: usersLAO,
          loadingUsers: loadingusersLAO
        };
      default:
        return {};
    }
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = "warning") => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;
    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === "application/pdf";
    } else {
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes(".pdf");
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    if (fileUrlToView.startsWith("blob:")) URL.revokeObjectURL(fileUrlToView);
    setFileUrlToView("");
    setIsPDFToView(false);
  };

  const isEditable = (row) => {
    return row.vargikaran === 'Yes';
  };

  const groupedRows = rows.reduce((groups, row) => {
    const village = row.villageName || 'माहिती नाही';
    if (!groups[village]) {
      groups[village] = [];
    }
    groups[village].push(row);
    return groups;
  }, {});

  if (loading) {
    return <div>Loading data...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8 relative">
      
      {/* Top Action Notifications */}
      {notification.show && (
        <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg max-w-md z-50 flex items-center ${notification.type === "success" ? "bg-green-100 border-l-4 border-green-500 text-green-700" : "bg-red-100 border-l-4 border-red-500 text-red-700"} transform transition-transform duration-300 animate-slideInRight`}>
          <div className="mr-3">
            {notification.type === "success" ? (
              <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
            ) : (
              <svg className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
            )}
          </div>
          <div>
            <p className="font-bold">{notification.type === "success" ? "Success!" : "Error!"}</p>
            <p>{notification.message}</p>
          </div>
          <button onClick={() => setNotification({ ...notification, show: false })} className="ml-auto text-gray-600 hover:text-gray-800">
            <X className="h-4 w-4" />
          </button>
        </div>
      )}

      <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-8">
        
        {/* Forwarding Actions Toolbar */}
        <div className="flex flex-wrap items-center justify-end gap-3 mb-6 p-3 bg-purple-50 border border-purple-200 rounded-xl shadow-sm">
          {userRole === ROLES.LAO && (
            <button type="button" onClick={() => { if (isSamanvay) { showConfirm("Confirm Resubmission", "Warning: Resubmitting.", () => setActiveModal("SAMANVAY"), () => {}, "danger"); } else { setActiveModal("SAMANVAY"); } }} className={`flex items-center justify-center px-4 py-2 text-sm font-medium h-10 whitespace-nowrap rounded-lg transition-colors shadow-sm ${isSamanvay ? "bg-red-600 text-white hover:bg-red-700" : "bg-purple-600 text-white hover:bg-purple-700"}`}>
              <Send className="mr-2 h-4 w-4" />
              {translations?.[language]?.SendToSamanvayOfficer || "Send to Samanvay"}
            </button>
          )}
          {userRole === ROLES.COLLECTOR && (
            <button type="button" onClick={() => { if (isSamanvayFinal) { showConfirm("Confirm Resubmission", "Warning: Resubmitting.", () => setActiveModal("SAMANVAY"), () => {}, "danger"); } else { setActiveModal("SAMANVAY"); } }} className={`flex items-center justify-center px-4 py-2 text-sm font-medium h-10 whitespace-nowrap rounded-lg transition-colors shadow-sm ${isSamanvayFinal ? "bg-red-600 text-white hover:bg-red-700" : "bg-purple-600 text-white hover:bg-purple-700"}`}>
              <Send className="mr-2 h-4 w-4" />
              {translations?.[language]?.SendToSamanvayOfficer || "Send to Samanvay"}
            </button>
          )}
          {userRole === ROLES.SAMANVAY && (
            <>
              <button type="button" onClick={() => { if (isCollector) { showConfirm("Confirm Resubmission", "Warning: Resubmitting.", () => setActiveModal("COLLECTOR"), () => {}, "danger"); } else { setActiveModal("COLLECTOR"); } }} className={`flex items-center justify-center px-4 py-2 text-sm font-medium h-10 whitespace-nowrap rounded-lg transition-colors shadow-sm ${isCollector ? "bg-red-600 text-white hover:bg-red-700" : "bg-purple-600 text-white hover:bg-purple-700"}`}>
                <Send className="mr-2 h-4 w-4" />
                {translations?.[language]?.SendToCollector || "Send to Collector"}
              </button>
              <button type="button" onClick={() => { if (isLAO) { showConfirm("Confirm Resubmission", "Warning: Resubmitting.", () => setActiveModal("LAO"), () => {}, "danger"); } else { setActiveModal("LAO"); } }} className={`flex items-center justify-center px-4 py-2 text-sm font-medium h-10 whitespace-nowrap rounded-lg transition-colors shadow-sm ${isLAO ? "bg-red-600 text-white hover:bg-red-700" : "bg-purple-600 text-white hover:bg-purple-700"}`}>
                <Send className="mr-2 h-4 w-4" />
                {translations?.[language]?.sendToLAO || "Send to LAO"}
              </button>
            </>
          )}
        </div>

        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-indigo-900 mb-2">
            निवडा साडी अंतिम करणे
          </h1>
          <h2 className="text-xl font-semibold text-indigo-700 mb-4">
            क्षेत्र वगळणची कार्यवाही
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border-2 border-indigo-300">
            <thead>
              <tr className="bg-indigo-600 text-white">
                <th className="border-2 border-indigo-400 px-4 py-3 text-left">अ.क्र.</th>
                <th className="border-2 border-indigo-400 px-4 py-3 text-left">गट नं</th>
                <th className="border-2 border-indigo-400 px-4 py-3 text-left">वगळण</th>
                <th className="border-2 border-indigo-400 px-4 py-3 text-left">क्षेत्र (हे.आर)</th>
                <th className="border-2 border-indigo-400 px-4 py-3 text-left">भूधाराकाचे नाव</th>
                <th className="border-2 border-indigo-400 px-4 py-3 text-center">कृती</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedRows).map(([villageName, villageRows]) => (
                <React.Fragment key={villageName}>
                  <tr className="bg-indigo-200">
                    <td 
                      colSpan="6" 
                      className="border-2 border-indigo-300 px-4 py-2 font-bold text-indigo-900 text-center text-lg"
                    >
                      गाव: {villageName}
                    </td>
                  </tr>

                  {villageRows.map((row, index) => (
                    <tr key={row.id} className="hover:bg-indigo-50 transition-colors">
                      <td className="border-2 border-indigo-200 px-4 py-3 font-semibold">
                        {index + 1}
                      </td>
                      <td className="border-2 border-indigo-200 px-4 py-3">
                        <input
                          type="text"
                          value={row.surveyNo}
                          disabled
                          className="w-full px-3 py-2 cursor-not-allowed"
                          placeholder="गट नं"
                        />
                      </td>
                      <td className="border-2 border-indigo-200 px-4 py-3">
                        <select
                          value={row.vargikaran}
                          onChange={(e) => handleDropdownChange(row.id, 'vargikaran', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
                        >
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </select>
                      </td>
                      <td className="border-2 border-indigo-200 px-4 py-3">
                        <input
                          type="text"
                          value={row.kshetra}
                          disabled
                          className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
                          placeholder=""
                        />
                        {isEditable(row) && (
                          <input
                            type="text"
                            value={row.kshetraNew}
                            onChange={(e) => handleInputChange(row.id, 'kshetraNew', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
                            placeholder="नवीन क्षेत्र प्रविष्ट करा"
                          />
                        )}
                      </td>
                      <td className="border-2 border-indigo-200 px-4 py-3">
                        <input
                          type="text"
                          value={row.bhudharanBadal}
                          disabled
                          className="w-full px-3 py-2 mb-2 border border-gray-200 bg-gray-100 cursor-not-allowed text-black-400"
                          placeholder=""
                        />
                        {isEditable(row) && (
                          <input
                            type="text"
                            value={row.bhudharanBadalNew}
                            onChange={(e) => handleInputChange(row.id, 'bhudharanBadalNew', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
                            placeholder="नवीन भूधाराकाचे नाव प्रविष्ट करा"
                          />
                        )}
                      </td>
                      <td className="border-2 border-indigo-200 px-4 py-3 text-center">
                        <button
                          onClick={() => handleSave(row.id)}
                          disabled={loading || !isEditable(row) || !editedFields[row.id]?.length}
                          className={`px-3 py-1 rounded font-semibold transition-colors ${loading || !isEditable(row) || !editedFields[row.id]?.length
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-blue-500 hover:bg-blue-600 text-white'
                            }`}
                        >
                          {loading ? 'Saving...' : 'सेव्ह करा'}
                        </button>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODALS AND PORTALS OVERLAYS */}
      {activeModal && (
        <DocumentForwardModal
          isOpen={!!activeModal}
          onClose={() => {
            setActiveModal(null);
            if (activeModal === 'SAMANVAY' && resetSignatureState) resetSignatureState();
          }}
          targetRole={activeModal}
          currentUserRole={userRole}
          ROLES={ROLES}
          translations={translations}
          language={language}
          onSubmit={handleUnifiedSubmit}
          isSubmitting={isSubmittingTask}
          initialUser={restoredModalData.user}
          initialRemarks={restoredModalData.remarks}
          
          {...getModalConfig()} 
          
          uploadStatus={uploadStatus}
          selectedSignDocument={selectedSignDocument}
          setShowSignaturePad={setShowSignaturePad}
          setPdfForSigning={setPdfForSigning}
          handleViewDocument={handleViewDocument}
        />
      )}

      {/* Signature Pad Component */}
      {showSignaturePad && pdfForSigning && SignaturePad && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            if (signDocument) {
              signDocument(pdfForSigning, signaturesArray).then(() => {
                setPdfForSigning(null);
              });
            }
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {/* Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <h3 className="text-2xl font-bold text-gray-800">Document Preview</h3>
              <button onClick={closeDocumentViewer} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 text-xl font-bold">×</button>
            </div>
            <div className="h-[calc(95vh)] flex flex-col">
              <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200 flex items-center justify-center">
                {isPDFToView ? (
                  <iframe src={fileUrlToView} className="w-full h-full border-0 bg-white shadow-lg" title="PDF Preview"></iframe>
                ) : (
                  <img src={fileUrlToView} alt="File" className="w-full h-full object-contain shadow-lg" />
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">{confirmConfig.title}</h3>
              <p className="text-gray-600 text-sm mb-6 text-center">{confirmConfig.message}</p>
              <div className="flex gap-3">
                <button onClick={() => { setShowConfirmModal(false); if (confirmConfig.onCancel) confirmConfig.onCancel(); }} className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300">{translations?.[language]?.Cancel || "Cancel"}</button>
                <button onClick={() => { setShowConfirmModal(false); if (confirmConfig.onConfirm) confirmConfig.onConfirm(); }} className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700">{translations?.[language]?.Confirm || "Confirm"}</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Section93;
